{
  "contactModal": {
    "delete": {
      "cancel": "Annulla",
      "confirm": "Elimina",
      "error": {
        "contactWithInformationRequests": "contactWithInformationRequests",
        "default": "default",
        "title": "title"
      },
      "message": "Sei sicuro di voler eliminare questo contatto?",
      "success": "success",
      "title": "Elimina contatto"
    }
  },
  "contacts": {
    "buttons": {
      "add": "Aggiungi un contatto"
    },
    "table": {
      "headers": {
        "actions": "Azioni",
        "email": "Email",
        "id": "ID",
        "name": "Nome"
      }
    }
  },
  "productionSiteModal": {
    "actions": {
      "cancel": "Annulla",
      "delete": "Elimina",
      "save": "Salva"
    },
    "createTitle": "Nuovo sito di produzione",
    "delete": {
      "cancel": "Annulla",
      "confirm": "Elimina",
      "message": "Sei sicuro di voler eliminare questo sito di produzione?",
      "title": "Elimina Sito di Produzione"
    },
    "editTitle": "Modifica un sito di produzione",
    "errors": {
      "cityRequired": "La città è obrigatória",
      "coordinatesMaxDecimals": "Latitudine e longitudine possono avere al massimo 6 decimali",
      "countryMustBeValid": "Paese deve essere valido (es. FR, DE)",
      "internalCodeTooLong": "Il codice interno deve essere inferiore a 32 caratteri",
      "nameRequired": "Nome è obrigatório",
      "parentCompanyRequired": "parentCompanyRequired",
      "postalCodeTooShort": "Il codice postale deve essere di almeno 3 caratteri",
      "streetRequired": "La via è obrigatória",
      "streetTooShort": "La via deve essere di almeno 3 caratteri"
    },
    "labels": {
      "city": "Città",
      "country": "Paese",
      "internalCode": "Codice interno",
      "latitude": "Latitudine",
      "longitude": "Longitudine",
      "name": "Nome del sito di produzione",
      "parentCompany": "parentCompany",
      "performedActivities": "Attività svolte",
      "postalCode": "Codice postale",
      "registrationId": "ID di registrazione del sito",
      "street": "Via"
    },
    "placeholders": {
      "city": "es. Casablanca",
      "country": "Seleziona il paese del sito",
      "internalCode": "es. BD-DAK-001 o riferimento interno",
      "latitude": "Latitudine",
      "longitude": "Longitudine",
      "name": "es. Unità Taglio e Cucito Dhaka A",
      "performedActivities": "es. Taglio, cucito, finitura, tintura",
      "postalCode": "Codice postale",
      "registrationId": "es. P.IVA, CIN, GSTIN, USC",
      "street": "Via"
    },
    "registrationIdDescriptions": {
      "DUNS": "DUNS: 9 cifre.",
      "EORI": "EORI: codice paese + 14 cifre.",
      "GLN": "GLN: 13 cifre.",
      "OTHER": "Altro: max 32 caratteri.",
      "RCS": "RCS: RCS + spazio + nome azienda + spazio + [A,B] + spazio + 9 cifre.",
      "VAT": "VAT: codice paese (es. FR) + 2 cifre + 9 cifre SIREN."
    },
    "registrationIdErrors": {
      "DUNS": "L'ID di registrazione DUNS deve essere un numero di 9 cifre.",
      "EORI": "L'ID di registrazione EORI deve essere nel formato: codice paese (es. FR) + 14 cifre.",
      "GLN": "L'ID di registrazione GLN deve essere un numero di 13 cifre.",
      "OTHER": "L'ID di registrazione altro deve essere inferiore a 32 caratteri.",
      "RCS": "L'ID di registrazione RCS deve essere nel formato: RCS + spazio + nome azienda + spazio + [A,B] + spazio + 9 cifre.",
      "VAT": "L'ID di registrazione VAT deve essere nel formato: codice paese (es. FR) + chiave 2 cifre + numero SIREN 9 cifre."
    },
    "tabs": {
      "generalInfo": "Informazioni generali",
      "location": "Posizione"
    },
    "tooltips": {
      "address": "Il tuo indirizzo di spedizione",
      "city": "Città",
      "country": "Paese del sito di produzione",
      "internalCode": "Codice interno del sito di produzione",
      "latitude": "Latitudine",
      "longitude": "Longitudine",
      "name": "Nome del sito di produzione",
      "parentCompany": "parentCompany",
      "performedActivities": "Attività svolte nel sito di produzione",
      "postalCode": "Codice postale",
      "registrationId": "ID di registrazione del sito di produzione",
      "street": "Via"
    }
  },
  "productionSites": {
    "buttons": {
      "add": "Aggiungi un sito di produzione"
    },
    "create": {
      "error": "Errore al creare il sito di produzione",
      "success": {
        "message": "Il sito di produzione è stato creato correttamente",
        "title": "Sito di produzione creato"
      }
    },
    "delete": {
      "error": "Errore al eliminare il sito di produzione",
      "success": {
        "message": "Il sito di produzione è stato eliminato correttamente",
        "title": "Sito di produzione eliminato"
      }
    },
    "filters": {
      "country": "Paese",
      "internalCode": "Codice interno",
      "isConfidential": "Riservato",
      "isConfidentialFalse": "No",
      "isConfidentialTrue": "Sì",
      "name": "Nome del sito di produzione",
      "nothingFoundMessage": "nothingFoundMessage",
      "performedActivities": "Attività svolte",
      "searchPlaceholder": "Cerca filtri",
      "title": "Filtri"
    },
    "search": {
      "placeholder": "Cerca per nome o indirizzo"
    },
    "sorts": {
      "address": "Indirizzo",
      "country": "Paese",
      "email": "Email",
      "internalCode": "Codice interno",
      "name": "Nome"
    },
    "table": {
      "headers": {
        "address": "Indirizzo",
        "certificates": "Certificati",
        "deleted": "Eliminato",
        "id": "ID",
        "internalCode": "Codice interno",
        "name": "Nome",
        "parentCompany": "Azienda madre",
        "performedActivities": "Attività svolte",
        "registrationId": "ID di registrazione del sito"
      }
    },
    "title": "Siti di Produzione",
    "update": {
      "error": "Errore al aggiornare il sito di produzione",
      "success": {
        "message": "Il sito di produzione è stato aggiornato correttamente",
        "title": "Sito di produzione aggiornato"
      }
    }
  },
  "request": {
    "errors": {
      "generic": "Errore"
    }
  }
}
